import { render, staticRenderFns } from "./CertificadoTabsPanel.vue?vue&type=template&id=65a7810a&scoped=true"
import script from "./CertificadoTabsPanel.vue?vue&type=script&lang=js"
export * from "./CertificadoTabsPanel.vue?vue&type=script&lang=js"
import style0 from "./CertificadoTabsPanel.vue?vue&type=style&index=0&id=65a7810a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7810a",
  null
  
)

export default component.exports